import React, { useState, useMemo } from "react";
import { Box, Typography, IconButton, Chip, Dialog } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import TableContainerComp from "../../Component/TableContainer";
import { color } from "../../StyleData/Config";
import { samplePMCals, getStatusBadgeClass, getStatusLabel } from "./pmCalData";
import PMCalViewPopup from "./PMCalViewPage";
import "../../css/calibration.css";

const PMCalListPage = () => {
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedPmCal, setSelectedPmCal] = useState(null);

  const handleViewClick = (pmCal) => {
    setSelectedPmCal(pmCal);
    setViewOpen(true);
  };

  const handleViewClose = () => {
    setViewOpen(false);
    setSelectedPmCal(null);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    return new Date(dateStr).toLocaleDateString();
  };

  const columns = useMemo(
    () => [
      {
        Header: "PM-Cal ID",
        accessor: "id",
        Cell: ({ cell }) => (
          <Box>
            <Typography
              sx={{ fontWeight: 700, color: "#2362B4", fontSize: "12px" }}
            >
              {cell.value}
            </Typography>
            {cell.row.original.source === "Oriens EAM" && (
              <Typography sx={{ fontSize: "11px", color: "#3b82f6" }}>
                <i className="bi bi-link-45deg"></i> <strong>Oriens EAM</strong>{" "}
                <span style={{ color: "#6b7280" }}>
                  {cell.row.original.eamWorkOrderNo}
                </span>
              </Typography>
            )}
          </Box>
        ),
      },
      {
        Header: "Asset",
        accessor: "assetName",
      },
      {
        Header: "Tool",
        accessor: "toolName",
      },
      {
        Header: "Start Date",
        accessor: "plannedStartDate",
        Cell: ({ cell }) => formatDate(cell.value),
      },
      {
        Header: "Due Date",
        accessor: "plannedDueDate",
        Cell: ({ cell }) => formatDate(cell.value),
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ cell }) => (
          <Chip
            label={getStatusLabel(cell.value)}
            size="small"
            sx={{
              fontWeight: 600,
              fontSize: "11px",
              color: "#fff",
              backgroundColor:
                cell.value === "completed"
                  ? "#10b981"
                  : cell.value === "pending"
                    ? "#f59e0b"
                    : cell.value === "in-progress"
                      ? "#3b82f6"
                      : cell.value === "overdue"
                        ? "#ef4444"
                        : "#6c757d",
            }}
          />
        ),
      },
      {
        Header: "Actions",
        Cell: ({ cell }) => (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton
              onClick={() => handleViewClick(cell.row.original)}
              size="small"
            >
              <Visibility
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
          </Box>
        ),
      },
    ],
    [],
  );

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          PM-Cal List
        </Typography>
      </Box>

      <TableContainerComp
        columns={columns}
        data={samplePMCals}
        loading={false}
        buttonDisable={true}
      />

      <Dialog open={viewOpen} onClose={handleViewClose} maxWidth="lg" fullWidth>
        {selectedPmCal && (
          <PMCalViewPopup pmCal={selectedPmCal} onClose={handleViewClose} />
        )}
      </Dialog>
    </>
  );
};

export default PMCalListPage;
